import { DateTime } from 'luxon';

import { IANATimeZone, ISO8601 } from '../types';

export function isoTimeToHour(time: ISO8601, timeZone: IANATimeZone | undefined): number {
    return DateTime.fromISO(time, { zone: timeZone }).hour;
}
